<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="green">
                        <v-toolbar-title class="my-0 py-0">Equipos / Herramientas / Instrumentos</v-toolbar-title>
                        <v-spacer></v-spacer>
                        Código: {{ codgral }}
                    </v-toolbar>
                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="9" md="9">
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-select item-color="green" color="green darken-2" dense v-model="codigo"
                                            :items="listadocodigo" label="Tipo de Equipo" item-text="nombre"
                                            item-value="valor" @change="armarcodigo()"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="8">
                                        <v-text-field color="green darken-2" dense v-model="detalle"
                                            label="Descripción"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field color="green darken-2" dense v-model="marca"
                                            label="Marca"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="4">
                                        <v-text-field color="green darken-2" dense v-model="modelo"
                                            label="Modelo"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="4">
                                        <v-text-field color="green darken-2" dense v-model="tipoequipo"
                                            label="Tipo"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field color="green darken-2" dense v-model="capacidad"
                                            label="Capacidad"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="2">
                                        <v-text-field color="green darken-2" dense v-model="anio"
                                            label="Año"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="3">
                                        <v-text-field color="green darken-2" dense v-model="numserie"
                                            label="N° de Serie"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field color="green darken-2" dense v-model="detalleprotocolo"
                                            label="Detalle p/Protocolo"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea color="green darken-2" auto-grow rows="2" label="Observaciones"
                                            dense v-model="observ"></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="2">
                                        <v-select item-color="green" color="green darken-2" dense v-model="alquila"
                                            :items="listadoalquila" label="Alquila?" item-text="nombre"
                                            item-value="valor"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="2" v-if="alquila == 'S'">
                                        <v-text-field color="green darken-2" dense v-model="vdiario"
                                            label="Valor Diario"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="2" v-if="alquila == 'S'">
                                        <v-text-field color="green darken-2" dense v-model="vsemanal"
                                            label="Valor Semanal"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="2" v-if="alquila == 'S'">
                                        <v-text-field color="green darken-2" dense v-model="vquincenal"
                                            label="Valor Quincenal"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="2" v-if="alquila == 'S'">
                                        <v-text-field color="green darken-2" dense v-model="vmensual"
                                            label="Valor Mensual"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="2" v-if="alquila == 'S'">
                                        <v-text-field color="green darken-2" dense v-model="fechacosto"
                                            label="Fecha Actualizac."></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6" md="2">
                                <div v-if="previewImage == null && !isCameraOpen" class="imagePreviewWrapper"
                                    @click="selectImage"><v-img contain src="../../../../public/images/subirfoto.jpg"
                                        max-height="200px" max-width="200px"></v-img></div>
                                <div v-if="previewImage != null && !isCameraOpen" class="imagePreviewWrapper"
                                    :style="{ 'background-image': `url(${previewImage})` }" @click="selectImage"></div>
                                <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box"
                                    :class="{ 'flash': isShotPhoto }">

                                    <div class="camera-shutter" :class="{ 'flash': isShotPhoto }"></div>

                                    <video v-show="!isPhotoTaken" ref="camera" :width="150" :height="200" autoplay
                                        @click="takePhoto"></video>
                                    <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="150"
                                        :height="200" @click="takePhoto"></canvas>
                                </div>
                            </v-col>
                            <v-col cols="6" sm="6" md="1">

                                <input style="display: none;" type="file" @change="pickFile" id="input" ref="fileInput">
                                <div class="camera-button">
                                    <v-btn small rounded :color="isCameraOpen ? 'red' : 'green'" @click="toggleCamera">
                                        <span v-if="!isCameraOpen">Open Camera</span>
                                        <span v-else>Close Camera</span>
                                    </v-btn>
                                </div>
                                <!-- <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
                                        <v-btn icon @click="takePhoto"><v-icon>mdi-camera</v-icon>
                                        </v-btn>
                                    </div> -->

                                <!-- <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
                                        <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button"
                                            @click="downloadImage">
                                            Download
                                        </a>
                                    </div> -->

                            </v-col>
                            <!-- <v-col cols="3" sm="1" md="1">
                                <v-btn @click="startCapture">Abrir Cámara</v-btn>
                            </v-col> -->
                        </v-row>
                        <v-row>
                            <!-- <div class="camera-button">
                                <v-btn small rounded :color="isCameraOpen ? 'red' : 'green'" @click="toggleCamera">
                                    <span v-if="!isCameraOpen">Open Camera</span>
                                    <span v-else>Close Camera</span>
                                </v-btn>
                            </div> -->
                            <!-- <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box"
                                :class="{ 'flash': isShotPhoto }">

                                <div class="camera-shutter" :class="{ 'flash': isShotPhoto }"></div>

                                <video v-show="!isPhotoTaken" ref="camera" :width="200" :height="200" autoplay></video>

                                <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="200"
                                    :height="200"></canvas>
                            </div>

                            <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
                                <button type="button" class="button" @click="takePhoto">
                                    <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
                                </button>
                            </div>

                            <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
                                <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button"
                                    @click="downloadImage">
                                    Download
                                </a>
                            </div> -->
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="green lighten-5" dense class="py-0 my-0">
                    <v-card-text>
                        <v-row dense v-if="codigo == 'E' || codigo == 'M' || codigo == 'C' || codigo == 'S'">
                            <v-col cols="6" sm="6" md="4">
                                <v-select item-color="green" color="green darken-2" dense v-model="control"
                                    :items="listadocontrol" label="Tipo de Control" item-text="nombre"
                                    item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-select v-if="control == 'C' || control == 'P' || control == 'E'" item-color="green"
                                    color="green darken-2" dense v-model="tipo" :items="listadotipocalib"
                                    label="Tipo de Calibración" item-text="nombre" item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <v-text-field color="green darken-2"
                                    v-if="control == 'C' || control == 'P' || control == 'E'" dense v-model="frecuencia"
                                    label="Frecuencia en meses"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="4" md="3">
                                <v-text-field color="green darken-2"
                                    v-if="control == 'C' || control == 'P' || control == 'E'" dense
                                    v-model="fechaultcalib" label="Fecha última calibración / ensayo"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense v-if="codigo == 'H' || codigo == 'V' || codigo == 'O'">
                            <v-col cols="6" sm="6" md="4">
                                <v-select item-color="green" color="green darken-2" dense v-model="manten"
                                    :items="listadomanten" label="Mantenimiento Preventivo" item-text="nombre"
                                    item-value="valor"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card v-if="codigo == 'E' || codigo == 'M' || codigo == 'C'" color="green lighten-4">
                    <v-card-text>
                        <h6 style="color:darkgreen">Instrumentos que componen el equipo</h6>
                        <v-data-table dense :headers="headers" :items="instrumentos" locale="es-ar" height="300"
                            fixed-header class="elevation-1" :items-per-page="200" hide-default-footer>
                            <template v-slot:item.instrumento="{ item }">
                                <!-- <div class="right-input"> -->
                                <v-text-field dense v-model="item.instrumento" outlined></v-text-field>
                                <!-- </div> -->
                            </template>
                            <template v-slot:item.tipo="{ item }">
                                <div class="d-flex justify-center">
                                    <v-select dense v-model="item.tipo" :items="listadoinstrumentos" outlined
                                        item-text="nombre" item-value="valor"></v-select>
                                </div>
                            </template>
                            <template v-slot:item.detalle="{ item }">
                                <v-textarea dense auto-grow rows="1" outlined v-model="item.detalle"></v-textarea>
                            </template>
                            <template v-slot:item.observ="{ item }">
                                <v-textarea dense auto-grow rows="1" outlined v-model="item.observ"></v-textarea>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-btn dense class="mx-2" dark small color="orange" @click="addRow('I')">Agregar fila</v-btn>
                </v-card>
                <v-card v-if="(codigo == 'H' || codigo == 'V' || codigo == 'O') && manten == 'S'"
                    color="green lighten-4">
                    <v-card-text>
                        <h6 style="color:darkgreen">Mantenimientos Preventivos</h6>
                        <v-data-table dense :headers="headersM" :items="mantenimiento" height="300" fixed-header
                            locale="es-ar" class="elevation-1" :items-per-page="200" hide-default-footer>
                            <template v-slot:item.tarea="{ item }">
                                <div class="right-input">
                                    <v-text-field dense v-model="item.tarea" single-line></v-text-field>
                                </div>
                            </template>
                            <template v-slot:item.repuesto="{ item }">
                                <div class="right-input">
                                    <v-text-field dense v-model="item.repuesto" single-line></v-text-field>
                                </div>
                            </template>
                            <template v-slot:item.frecuencia="{ item }">
                                <div class="right-input">
                                    <v-text-field type="number" dense v-model="item.frecuencia"
                                        single-line></v-text-field>
                                </div>
                            </template>
                            <template v-slot:item.unidad="{ item }">
                                <div class="d-flex justify-center">
                                    <v-select dense v-model="item.unidad" :items="listadounidad" item-text="nombre"
                                        item-value="valor"></v-select>
                                </div>
                            </template>
                            <template v-slot:item.alerta="{ item }">
                                <div class="d-flex justify-center">
                                    <v-text-field dense v-model="item.alerta" single-line></v-text-field>
                                </div>
                            </template>
                            <template v-slot:item.observ="{ item }">
                                <v-textarea dense auto-grow rows="1" v-model="item.observ"></v-textarea>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-btn dense class="mx-2" dark small color="orange" @click="addRow('M')">Agregar fila</v-btn>
                </v-card>
                <v-card color="green lighten-5" class="py-0 my-0">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="8" sm="8" md="8">
                                <v-select item-color="green" color="green darken-2" dense v-model="lugar"
                                    :items="listadolugar" label="Área Responsable / Emplazamiento Habitual"
                                    item-text="nombre" item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="4" sm="4" md="4">
                                <v-select dense v-model="responsable" :items="listadoresponsable" label="Responsable"
                                    item-text="nombre" item-value="nombre"></v-select>

                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="blue lighten-4" class="py-0 my-0">
                    <v-card-text class="py-0 my-0">

                    </v-card-text>
                </v-card>

                <v-card color="green lighten-4">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="3" md="3">
                                <v-select item-color="green" color="green darken-2" dense v-model="activo"
                                    :items="estados" label="Estado" item-text="nombre" item-value="valor">
                                </v-select>

                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <v-text-field color="green darken-2" label="Fecha de Alta" dense
                                    v-model="fechaalta"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3" md="3">
                                <v-text-field color="green darken-2" label="Fecha de Baja" dense
                                    v-model="fechabaja"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-text>
                        <div>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <v-file-input color="green darken-2" multiple show-size label="Seleccionar Archivo"
                                        v-model="fotos" @change="selectFiles"></v-file-input>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field color="green darken-2" v-model="titulo" prepend-icon="mdi-text"
                                        label="Título" maxlength="45" dense
                                        hint="El título debe tener al menos 10 caracteres"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">
                                    <v-btn color="success" small @click="uploadFiles" :disabled="!validsubir">
                                        Subir Archivo
                                        <v-icon right dark>mdi-cloud-upload</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-card>
                <v-card v-if="fileInfos.length > 0" class="mx-auto">
                    <v-list>
                        <v-subheader>Lista de archivos</v-subheader>
                        <v-list-item-group color="primary">
                            <v-list-item v-for="(file, index) in fileInfos" :key="index">
                                <v-list-item-content>
                                    <v-list-item-title class="mb-3">
                                        <v-icon color="red"
                                            @click="borrarArchivo(file.descripcion, index)">mdi-close</v-icon>
                                        <a target="_blank" :href="'https://api.icssa.com.ar/informes/' + file.descripcion
                                            ">{{ file.titulo }}</a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
                <v-card color="green lighten-4" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        <!--
              <v-btn color="error" @click.stop="show = false">Salir</v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
    <!-- </v-dialog> -->
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}

.v-input--selection-controls {
    label {
        margin: 0 !important;
    }
}


.web-camera-container {
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 150px;


    .camera-button {
        margin-bottom: 2rem;
    }

    .camera-box {
        .camera-shutter {
            opacity: 0;
            width: 150px;
            height: 200px;
            background-color: #fff;
            position: absolute;

            &.flash {
                opacity: 1;
            }
        }
    }

    .camera-shoot {
        margin: 1rem 0;

        button {
            height: 60px;
            width: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100%;

            img {
                height: 35px;
                object-fit: cover;
            }
        }
    }

    // .camera-loading {
    //     overflow: hidden;
    //     height: 100%;
    //     position: absolute;
    //     width: 100%;
    //     min-height: 200px;
    //     margin: 3rem 0 0 -1.2rem;

    //     ul {
    //         height: 100%;
    //         position: absolute;
    //         width: 100%;
    //         z-index: 999999;
    //         margin: 0;
    //     }

    //     .loader-circle {
    //         display: block;
    //         height: 14px;
    //         margin: 0 auto;
    //         top: 50%;
    //         left: 100%;
    //         transform: translateY(-50%);
    //         transform: translateX(-50%);
    //         position: absolute;
    //         width: 100%;
    //         padding: 0;

    //         li {
    //             display: block;
    //             float: left;
    //             width: 10px;
    //             height: 10px;
    //             line-height: 10px;
    //             padding: 0;
    //             position: relative;
    //             margin: 0 0 0 4px;
    //             background: #999;
    //             animation: preload 1s infinite;
    //             top: -50%;
    //             border-radius: 100%;

    //             &:nth-child(2) {
    //                 animation-delay: .2s;
    //             }

    //             &:nth-child(3) {
    //                 animation-delay: .4s;
    //             }
    //         }
    //     }
    // }

    @keyframes preload {
        0% {
            opacity: 1
        }

        50% {
            opacity: .4
        }

        100% {
            opacity: 1
        }
    }
}
</style>

<style scoped>
.class label {
    margin-bottom: 0 !important;
}

.multi-line {
    white-space: pre-line;
}

.imagePreviewWrapper {
    width: 200px;
    height: 200px;
    display: block;
    cursor: pointer;
    margin: 0 auto 30px;
    background-size: cover;
    background-position: center center;

}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
import readXlsFile from "read-excel-file";
import Compressor from "compressorjs";
export default {
    data: (vm) => ({
        isCameraOpen: false,
        isPhotoTaken: false,
        isShotPhoto: false,
        isLoading: false,
        link: '#',
        video: null,
        canvas: null,
        mostrarvideo: false,
        codigo: "",
        codgral: "",
        tipo: "",
        tipoequipo: "",
        numserie: "",
        anio: "",
        listadocodigo: [
            { nombre: "Vehículo", valor: "V" },
            { nombre: "Equipo / Herramienta", valor: "H" },
            { nombre: "Contenedor / Oficina", valor: "O" },
            { nombre: "Instrumento Medición Eléctrica / Electrónica", valor: "E" },
            { nombre: "Instrumento Medición Mecánica", valor: "M" },
            { nombre: "Instrumento Civil", valor: "C" },
            { nombre: "Elemento de Seguridad", valor: "S" },
        ],
        listadotipocalib: [
            { nombre: "Analógico", valor: "A" },
            { nombre: "Digital", valor: "D" },
            { nombre: "Mecánico", valor: "M" },
            { nombre: "No Aplica", valor: "X" },
        ],
        detalle: "",
        detalleprotocolo: "",
        marca: "",
        modelo: "",
        capacidad: "",
        observ: "",
        control: "NC",
        frecuencia: "",
        fechaultcalib: moment().format("DD/MM/YYYY"),
        alquila: "N",
        listadoalquila: [
            { nombre: "SI", valor: "S" },
            { nombre: "NO", valor: "N" },
        ],
        vdiario: "",
        vsemanal: "",
        vquincenal: "",
        vmensual: "",
        fechacosto: "",
        listadocontrol: [
            { nombre: "Controlado", valor: "C" },
            { nombre: "No Controlado", valor: "NC" },
            { nombre: "Patrón", valor: "P" },
            { nombre: "Ensayado", valor: "E" },
        ],
        manten: "N",
        listadomanten: [
            { nombre: 'Sujeto', valor: 'S' },
            { nombre: 'No Sujeto', valor: 'N' },
        ],
        headers: [
            { text: "Instrumento", value: "instrumento", width: "25%", sortable: false },
            { text: "Tipo de Calibración", value: "tipo", width: "10%", sortable: false },
            { text: "Descripción", value: "detalle", width: "45%", sortable: false },
            { text: "Observaciones", value: "observ", width: "20%", sortable: false },
        ],
        instrumentos: [
            { instrumento: "", tipo: "", detalle: "", observ: "" },
            { instrumento: "", tipo: "", detalle: "", observ: "" },
            { instrumento: "", tipo: "", detalle: "", observ: "" },
        ],
        listadoinstrumentos: [
            { nombre: "Analógico", valor: "A" },
            { nombre: "Digital", valor: "D" },
            { nombre: "Mecánico", valor: "M" },
        ],
        headersM: [
            { text: "Item", value: "item", width: "5%", sortable: false },
            { text: "Tarea", value: "tarea", width: "40%", sortable: false },
            { text: "Repuesto", value: "repuesto", width: "10%", sortable: false },
            { text: "Frecuencia", value: "frecuencia", width: "10%", sortable: false },
            { text: "Unidad", value: "unidad", width: "5%", sortable: false },
            { text: "Alerta", value: "alerta", width: "10%", sortable: false },
            { text: "Observaciones", value: "observ", width: "20%", sortable: false },
        ],
        mantenimiento: [
            { item: "1", tarea: "", repuesto: "", frecuencia: "", unidad: "", alerta: "", observ: "" },
            { item: "2", tarea: "", repuesto: "", frecuencia: "", unidad: "", alerta: "", observ: "" },
            { item: "3", tarea: "", repuesto: "", frecuencia: "", unidad: "", alerta: "", observ: "" },
            { item: "4", tarea: "", repuesto: "", frecuencia: "", unidad: "", alerta: "", observ: "" },
        ],
        count: "4",
        listadounidad: [
            { nombre: "Meses", valor: "Meses" },
            { nombre: "Km", valor: "Km" },
            { nombre: "Horas", valor: "Horas" },
        ],
        lugar: "",
        listadolugar: [
            { nombre: "SSGG y Mantenimiento", valor: "SSGG y Mantenimiento" },
            { nombre: "Inspección y Ensayos", valor: "Inspección y Ensayos" },
            { nombre: "Abastecimiento", valor: "Abastecimiento" },
            { nombre: "Administración y Finanzas", valor: "Administración y Finanzas" },
            { nombre: "Comercial", valor: "Comercial" },
            { nombre: "Comité del SGI", valor: "Comité del SGI" },
            { nombre: "Control de Gestión", valor: "Control de Gestión" },
            { nombre: "Depósito", valor: "Depósito" },
            { nombre: "Fabricación", valor: "Fabricación" },
            { nombre: "Gerencia del SGI", valor: "Gerencia del SGI" },
            { nombre: "Ingeniería de Obra", valor: "Ingeniería de Obra" },
            { nombre: "Ingeniería de Producto", valor: "Ingeniería de Producto" },
            { nombre: "Medicina Laboral", valor: "Medicina Laboral" },
            { nombre: "Obras y Servicios", valor: "Obras y Servicios" },
            { nombre: "Personal y RRHH", valor: "Personal y RRHH" },
            { nombre: "Técnica y Desarrollo", valor: "Técnica y Desarrollo" },
        ],
        responsable: "",
        listadoresponsable: [],
        activo: "A",
        estados: [
            { nombre: 'Activo', valor: 'A' },
            { nombre: 'Inactivo', valor: 'I' },
        ],
        fechaalta: moment().format("DD/MM/YYYY"),
        fechabaja: "",
        instrum: [],
        mantenim: [],
        selectedFile: null,
        fotos: [],
        previewImage: null,
        valid: false,
        validsubir: false,
        deshabilitar: false,
        lazy: false,
        usuario: "",
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        direcciones: [],
        direccion: "",
        correos: "",
        destinatarios: [],
        mail: [{ address: "" }],
        date: moment().format("YYYY-MM-DD"),
        menu: false,
        selectedFiles: "",
        progressInfos: [],
        archivo: [],
        rulesarchivos: [
            (value) =>
                !value || value.size < 3000000 || "Las fotos deben pesar 3MB o menos",
        ],
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        selectedFiles: undefined,
        progressInfos: [],
        message: "",
        titulo: "",
        titulofoto: "",
        fileInfos: [],
        foto: "",
    }),
    watch: {
        titulo(val) {
            if (this.titulo.length > 3 && this.codigo != null && this.codigo != "") {
                this.validsubir = true;
            } else {
                this.validsubir = false;
            }
        },

    },

    computed: {

        fecha() {
            return this.formatDate(this.date)
        },
        show: {
            get() {
                this.cargarResponsable();
                // this.responsable = this.$store.state.nombre.toString().trim();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        toggleCamera() {
            if (this.isCameraOpen) {
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
                this.stopCameraStream();
            } else {
                this.isCameraOpen = true;
                this.createCameraElement();
            }
        },

        createCameraElement() {
            this.isLoading = true;
            const facemode = '';
            if (window.innerWidth < '760') {
                const constraints = (window.constraints = {
                    audio: false,
                    video: {
                        facingMode: { exact: 'environment' },
                        // Esto seleccionará la cámara trasera
                    },
                });
            }
            else {
                const constraints = (window.constraints = {
                    audio: false,
                    video: {
                        facingMode: { exact: 'user' },
                        // Esto seleccionará la cámara delantera
                    },
                });
            }



            navigator.mediaDevices
                .getUserMedia(constraints)
                .then(stream => {
                    this.isLoading = false;
                    this.$refs.camera.srcObject = stream;
                })
                .catch(error => {
                    this.isLoading = false;
                    alert("May the browser didn't support or there is some errors.");
                });
        },

        stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks();

            tracks.forEach(track => {
                track.stop();
            });
        },

        takePhoto() {
            if (!this.isPhotoTaken) {
                this.isShotPhoto = true;

                const FLASH_TIMEOUT = 50;

                setTimeout(() => {
                    this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }

            this.isPhotoTaken = !this.isPhotoTaken;
            const context = this.$refs.canvas.getContext('2d');

            context.drawImage(this.$refs.camera, 0, 0, 150, 200);

            this.downloadImage();

        },

        downloadImage() {
            const canvas = document.getElementById("photoTaken").toBlob((blob) => {
                let file = new File([blob], "foto.jpg", { type: "image/jpeg" });
                this.foto = file
            }, 'image/jpeg');

        },

        selectImage() {
            this.$refs.fileInput.click()
        },

        pickFile(event) {
            let input = this.$refs.fileInput
            this.selectedFile = event.target.files[0]
            let file = input.files
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.previewImage = e.target.result
                }
                reader.readAsDataURL(file[0])
                this.$emit('input', file[0])
            }

            console.log("SELECTED FILE" + this.selectedFile)
        },


        addRow(flag) {
            if (flag == "I") {
                this.instrumentos.push({ instrumento: "", tipo: "", detalle: "", observ: "" })
            }
            if (flag == "M") {
                this.count = parseInt(this.count) + 1
                this.mantenimiento.push({ item: this.count, tarea: "", repuesto: "", frecuencia: "", unidad: "", alerta: "", observ: "" },)
            }
        },

        cargarResponsable() {
            let self = this;
            axios
                .get("/Icssa/CargarLegajo?")
                .then((response) => {
                    self.listadoresponsable = response.data;
                })
                .catch((error) => {
                    self.listadoresponsable = [];
                    console.log(error);
                });
        },
        armarcodigo() {
            const codigo = this.codigo;
            let self = this;
            console.log("CODIGO" + this.codigo)
            axios
                .get("/SSGG/CodigoEquipo?", {
                    params: {
                        tipo: codigo,
                    },
                })
                .then((response) => {
                    //self.codigo = response.data;
                    self.codgral = response.data;
                    self.titulofoto = "FOTO" + self.codgral;
                })
                .catch((error) => {
                    self.codgral = "";
                    console.log(error);
                });
        },

        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}-`;
        },

        vaciarModels() {
            this.lugar = "";
            this.tipo = "";
            this.tipoequipo = "";
            this.anio = "";
            this.numserie = "";
            this.tipocalib = "";
            this.detalle = "";
            this.detalleprotocolo = "";
            this.marca = "";
            this.modelo = "";
            this.observ = "";
            this.activo = "";
            this.responsable = "";
            this.capacidad = "";
            this.fechaalta = "";
            this.fechabaja = "";
            this.frecuencia = "";
            this.mantenimiento = [];
            this.instrumentos = [];
            this.mantenim = [];
            this.instrum = [];
            this.fileInfos = [];
            this.fotos = [];
            this.valid = false;
            this.validsubir = false;
            this.lazy = false;
            this.area = "";
            if (this.isCameraOpen) {
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
                this.stopCameraStream();
            }
            this.$router.push({ name: "Main" });
        },

        selectFiles(files) {
            this.progressInfos = [];
            this.selectedFiles = files;
        },

        uploadFiles() {
            this.message = "";
            for (let i = 0; i < this.selectedFiles.length; i++) {
                console.log(" TODOS LOS ARCHIVOS " + this.selectedFiles)
                this.upload(i, this.selectedFiles[i]);
            }
        },

        upload(idx, file) {
            console.log("file " + file)
            const codigo = this.codgral;
            let self = this;
            let formData = new FormData();

            console.log("archivo: " + file.name + "codigo" + codigo);
            formData.append("path", file, file.name);
            formData.append("titulo", self.titulo);
            formData.append("descripcion", "");
            formData.append("tipo", "SE");
            // if (this.editar == true) {
            //   formData.append("codgral", self.codgral)
            // }
            // else {
            formData.append("codgral", self.codgral)
            // }
            axios
                .post("App/GuardarInformeGral", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    self.fileInfos.push({
                        url: response.data.path,
                        titulo: response.data.titulo,
                        descripcion: response.data.descripcion,
                    });
                    self.fotos = [];
                    self.titulo = "";
                    console.log(response.data.descripcion);
                })
                .catch((error) => {
                    console.log("ERROR:  " + error);
                    self.showAlert({
                        icon: "error",
                        title: "El archivo no se pudo subir",
                        vm: self,
                    });
                });

        },
        borrarArchivo(file, index) {
            let self = this;
            console.log("archivo a borrar:" + file);
            axios
                .get("/App/BorrarInformesGral?", {
                    params: {
                        ruta: file,
                    },
                })
                .then((response) => {
                    self.showAlert({
                        icon: "success",
                        title: "Archivo borrado",
                        vm: this,
                    });
                    self.fileInfos.splice(index, 1);
                })
                .catch((error) => {
                    console.log(error);
                });
        },


        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Equipo",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var i = 0;
                    var j = 0;
                    var foto = null;
                    const codgral = this.codgral;
                    if (this.selectedFile != null) {
                        foto = this.selectedFile
                    }
                    if (this.foto != null) {
                        foto = this.foto
                    }
                    console.log("FOTO: " + foto + codgral)
                    if (foto != null && foto != "") {
                        new Compressor(foto, {
                            quality: 0.4,
                            success(result) {
                                const formData = new FormData();
                                console.log("foto:" + result);
                                formData.append("foto", result, result.name);
                                formData.append("codgral", codgral);
                                // formData.append("foto", file);
                                formData.append("titulo", self.titulofoto);
                                formData.append("descripcion", "");

                                axios
                                    .post("SSGG/upload", formData, {
                                        headers: {
                                            "Content-Type": "multipart/form-data",
                                        },
                                    })
                                    .then((response) => {
                                        // self.fileInfos.push({
                                        //     url: response.data.path,
                                        //     title: response.data.titulofoto,
                                        //     descripcion: response.data.descripcion,
                                        // });
                                        // self.fotos = [];
                                        // self.titulofoto = "";
                                        console.log(response.data.descripcion);
                                    })
                                    // .then((files) => {
                                    //  this.fileInfos = files.name;
                                    //})
                                    .catch((error) => {
                                        console.log("ERROR:  " + error);
                                        self.showAlert({
                                            icon: "error",
                                            title:
                                                "La foto debe estar en formato .jpg y debe tener menos de 5MB",
                                            vm: self,
                                        });
                                    });
                            },
                        });
                    };
                    this.instrumentos.forEach((element) => {
                        if (element.instrumento != "" && element.instrumento != null) {
                            i = i + 1
                            this.instrum.push({
                                codinstrumento: i,
                                instrumento: element.instrumento,
                                tipo: element.tipo,
                                detalle: element.detalle,
                                observ: element.observ,
                            })
                        }
                    })
                    this.mantenimiento.forEach((element) => {
                        if (element.tarea != "" && element.tarea != null) {
                            this.mantenim.push({
                                item: element.item,
                                tarea: element.tarea,
                                repuesto: element.repuesto,
                                frecuencia: element.frecuencia,
                                unidad: element.unidad,
                                alerta: element.alerta,
                                observ: element.observ,
                            })
                        }
                    })
                    var datos = {

                        codgral: this.codgral,
                        codigo: this.codigo,
                        tipo: this.tipo,
                        tipoequipo: this.tipoequipo,
                        anio: this.anio,
                        numserie: this.numserie,
                        detalle: this.detalle,
                        detalleprotocolo: this.detalleprotocolo,
                        marca: this.marca,
                        modelo: this.modelo,
                        capacidad: this.capacidad,
                        observ: this.observ,
                        alquila: this.alquila,
                        vdiario: this.vdiario,
                        vsemanal: this.vsemanal,
                        vquincenal: this.vquincenal,
                        vmensual: this.vmensual,
                        fechacosto: this.fechacosto,
                        lugar: this.lugar,
                        responsable: this.responsable,
                        clasificacion: this.control,
                        manten: this.manten,
                        frecuencia: this.frecuencia,
                        fechaultcalib: this.fechaultcalib,
                        activo: this.activo,
                        fechaalta: this.fechaalta,
                        fechabaja: this.fechabaja,
                        instrumentos: this.instrum,
                        mantenimiento: this.mantenim,

                    };

                    let self = this;
                    console.log(datos)
                    axios
                        .post("/SSGG/GuardarEquipo", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Equipo guardado con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
